import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { saveToStorage, getFromStorage } from '@forvalter/utils/storage';
import { localStorageReferences } from '../utils/constants';

export interface IFrontpageState {
    storedSelectedFrontpageCards: Array<string>;
}

export interface IFrontpageStore {
    frontpage: IFrontpageState;
}

export const frontpageSelectors = ({
    frontpage,
}: IFrontpageStore): IFrontpageState => frontpage;

const saveSelectedFrontpageCardsToStorage = createAsyncThunk(
    'frontpage/saveSelectedFrontpageCardsToStorage',
    async (storedSelectedFrontpageCards: Array<string>) => {
        saveToStorage(
            localStorageReferences.SELECTED_FRONTPAGE_CARDS,
            storedSelectedFrontpageCards,
        );
        return storedSelectedFrontpageCards;
    },
);

const selectedFrontpageCardsFromStorage = getFromStorage(
    localStorageReferences.SELECTED_FRONTPAGE_CARDS,
) as Array<string>;

export const frontpageSlice = createSlice({
    name: 'frontpage',
    initialState: {
        storedSelectedFrontpageCards: selectedFrontpageCardsFromStorage,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            saveSelectedFrontpageCardsToStorage.fulfilled,
            (state, action) => {
                state.storedSelectedFrontpageCards = action.payload;
            },
        );
    },
});

export const frontpageActions = {
    saveSelectedFrontpageCardsToStorage,
    reducerActions: frontpageSlice.actions,
};
